import keycloak from '../keycloak';

/** Vérifie si l'utilisateur a un rôle donné (base ou module).
 *  Le JWT Keycloak stocke les rôles dans realm_access.roles (tableau). */
export function hasRole(user: any, ...roles: string[]): boolean {
    if (!user) return false;
    // ADMIN a accès à tout
    if (user.role === 'ADMIN') return true;
    // Les rôles sont dans realm_access.roles du JWT Keycloak
    const userRoles: string[] =
        user.realm_access?.roles ||   // JWT Keycloak parsé
        user.roles                 ||  // fallback tableau direct
        (user.role ? [user.role] : []); // fallback rôle unique
    return roles.some(r => userRoles.includes(r));
}

/** Vrai si le token Keycloak courant porte le rôle ADMIN — seul rôle autorisé à modifier
 *  une livraison déjà livrée (cf. LivraisonService.updateLivraison côté backend). */
export function estAdminConnecte(): boolean {
    const roles: string[] = keycloak.tokenParsed?.realm_access?.roles || [];
    return roles.includes('ADMIN');
}
